<template>
<div>
  <section class="content-header">
    <h1>
      学生充值卡明细
      <small>充值卡综合数据</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/operateDetails/operateDetails">充值卡综合数据</a></li>
      <li class="active">学生充值卡明细</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true" :model="filters">
				<el-form-item>
          <el-select v-model="filters.customer" filterable clearable placeholder="学校" @change="changeSchool" style="width: 360px">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
          <el-select v-model="filters.classId" filterable clearable placeholder="班级" style="width: 300px">
            <el-option
              v-for="item in classes"
              :key="item.group_id"
              :label="item.name"
              :value="item.group_id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
      <div class="duration">
        <span class="label">当前查询时间段：</span>
        <span class="value">{{dateRange[0]}} 至 {{dateRange[1]}}</span>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">运营详细数据</span>
        <el-button id="exportBtn" type="primary" icon="el-icon-download" @click="exportOperateDetails">导出</el-button>
      </div>
      <div class="sumTab">
        <table border="2px solid rgba(216, 220, 229, 1)">
          <tr>
            <th>&nbsp;</th>
            <th>当前有课率</th>
            <th>卡密充值总数</th>
            <th>两年卡充值总数</th>
            <th>年卡充值总数</th>
            <th>半年卡充值总数</th>
            <th>季卡充值总数</th>
            <th>两月卡充值总数</th>
            <th>月卡充值总数</th>
            <th>折合为月卡总数</th>
            <th>其他</th>
          </tr>
          <tr>
            <th>总计</th>
            <td>{{summary.valid_package_rate}}</td>
            <td>{{summary.order_times}}</td>
            <td>{{summary.month_24}}</td>
            <td>{{summary.month_12}}</td>
            <td>{{summary.month_6}}</td>
            <td>{{summary.month_3}}</td>
            <td>{{summary.month_2}}</td>
            <td>{{summary.month_1}}</td>
            <td>{{summary.convert_month_1}}</td>
            <td>{{summary.month_13}}</td>
          </tr>
        </table>
      </div>

       <div class="content">
        <el-table @sort-change="sortChange" border :data="operateDetails"  :default-sort = "{prop: 'date', order: 'descending'}" >
          <el-table-column
            prop="username"
            label="学生名称"
            sortable="custom"
            width="230">
          </el-table-column>
          <el-table-column
            prop="packages"
            label="当前课程名称"
            sortable="custom"
            align="center">
          </el-table-column>
          <el-table-column
            prop="times"
            label="充值卡密次数"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="month_24"
            label="充值两年卡次数"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="month_12"
            label="充值年卡次数"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="month_6"
            label="充值半年卡次数"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="month_3"
            label="充值季卡次数"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="month_2"
            label="充值两月卡次数"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="month_1"
            label="充值月卡次数"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="convert_month_1"
            label="折合为月卡张数"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="month_13"
            label="其他"
            sortable="custom"
            align="center"
            width="80">
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import $ from 'jquery'
import {baseUrl} from 'api/base'
import {mapGetters} from 'vuex'
import {getLastWeek, extractArrFromObj} from 'common/js/app-utils'
import {pagination, sortChange} from 'common/js/common-utils'
import {loadPackagesOrders} from 'api/operate-details'
import {loadClasses} from 'api/condition'
export default {
  computed: {
    ...mapGetters([
      'customers',
      'pickerOptions',
      'orgTypes'
    ])
  },
  data () {
    return {
      currentDate: new Date(),
      dateRange: [],
      classes: [],
      filters: {
        customer: '',
        classId: '',
        dateRange: [],
        orgType: ''
      },
      // pagination
      page: 1,
      total: 0,
      pageSize: 10,
      userListAll: [],
      // business
      operateDetails: [],
      summary: {}
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  methods: {
    sortChange (obj) {
      sortChange(obj, this.userListAll)
      this.handleCurrentChange(1)
    },
    pagination (page, pageSize, all) {
      this.operateDetails = pagination(page, pageSize, all)
      this.total = all.length
    },
    changeSchool (val) {
      this.filters.classId = ''
      this._loadClasses()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.pagination(1, val, this.userListAll)
    },
    handleCurrentChange (val) {
      this.page = val
      this.pagination(val, this.pageSize, this.userListAll)
    },
    exportOperateDetails () {
      let form = $('<form>')
      form.attr('style', 'display:none')
      form.attr('target', '')
      form.attr('method', 'post')
      form.attr('action', baseUrl + 'exports/exportOperateDetails')
      let input1 = $('<input>')
      let input2 = $('<input>')
      input1.attr('type', 'hidden')
      input1.attr('name', 'conditionStr')
      input1.attr('value', JSON.stringify(this.filters))
      input2.attr('type', 'hidden')
      input2.attr('name', 'token')
      input2.attr('value', localStorage.getItem('default_auth_token'))
      $('body').append(form)
      form.append(input1)
      form.append(input2)
      form.submit()
    },
    query () {
      this._showDateRange()
      this._loadPackagesOrders(this.filters)
    },
    _showDateRange () {
      let t = this.filters.dateRange
      if (t && t.length === 2) {
        this.dateRange = t
      } else {
        this.dateRange = getLastWeek()
      }
    },
    _loadPackagesOrders () {
      this.page = 1
      loadPackagesOrders(this.filters)
      .then((res) => {
        this.summary = res.summary
        this.userListAll = this._wrapUserList(res.user_list)
        this.handleSizeChange(this.pageSize)
      }, (msg) => {
        this.$message.error(msg)
        this.summary = {}
        this.userListAll = []
        this.handleSizeChange(this.pageSize)
      })
    },
    _loadClasses () {
      // 接口只接受多选，所以这里需要将单选转为多选
      let orgId = this.filters.customer
      let schoolIds = [orgId]
      loadClasses(schoolIds)
      .then((res) => {
        let ret = []
        extractArrFromObj(res, 'groups').every(arr => ret.push(...arr))
        this.classes = ret
      }, (msg) => {
        this.classes = []
      })
    },
    _wrapUserList (rawUserList) {
      let defaultOrders = {times: '-', month_1: '-', month_3: '-', month_6: '-', month_12: '-', month_13: '-', convert_month_1: '-'}
      let userList = []
      rawUserList.forEach((user) => {
        let _user = {}
        _user.userid = user.userid
        _user.username = user.username
        _user.packages = user.packages || '-'
        let _orders = user.orders || defaultOrders
        _user.times = _orders.times
        _user.month_1 = _orders.month_1
        _user.month_2 = _orders.month_2
        _user.month_3 = _orders.month_3
        _user.month_6 = _orders.month_6
        _user.month_12 = _orders.month_12
        _user.month_24 = _orders.month_24
        _user.month_13 = _orders.month_13
        _user.convert_month_1 = _orders.convert_month_1
        userList.push(_user)
      })
      return userList
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
  .sumTab
    margin-left 15px
    th,td
      padding 10px
</style>



// WEBPACK FOOTER //
// src/components/operate-details/operate-details.vue